import * as React from "react";
import {Component } from "react";

import {NavigationConfiguration} from "../../../config/navigation-configuration";
import {UiState} from "../../../core/ui-state";
import SVG from "react-inlinesvg";
import crossIcon from "../../../assets/images/layout/cross.svg";


export interface MobileNavigationProps {
    config: NavigationConfiguration;
    uiStore: UiState;
    handleNavigation: (route: string) => void;
}

export class MobileNavigation extends Component<MobileNavigationProps, any> {
    uiStore: UiState;
    constructor(props: MobileNavigationProps) {
        super(props);
        this.uiStore = this.props.uiStore;
        this.state = {
            search: null
        };
    }
    setSidebarVisible(sidebarVisible: boolean): void {
        this.uiStore.setSidebarVisible(sidebarVisible);
    }
    handleLocalUrl(event: React.MouseEvent): void {
        event.preventDefault();
        this.setSidebarVisible(false);
        this.props.handleNavigation((event.target as HTMLAnchorElement).pathname);
    }
    render(): React.ReactElement | null {
        const {config} = this.props;
        const naviItems: React.ReactElement[] = [];
        config.items.forEach((element, index) => {
            naviItems.push(<li className="navigation__list-item" key={"mobile-navigation-" + index}>
                <a href={element.href} target={element.target} onClick={(event: React.MouseEvent<HTMLAnchorElement>) =>
                    this.handleLocalUrl(event)}>{element.title}</a>
            </li>);
        });
        return(
            <div id="mobileNav" className="mobilenavigation">
                <div className="mobilenavigation__header">
                    <button className="no-focusborder offside-button mobilenavigation__close-button" type="button"
                        onClick={() => this.setSidebarVisible(false)}><span
                            className="sprite sprite--cross">
                            <SVG src={crossIcon} />

                        </span></button>
                </div>
                <div className="mobilenavigation__inner">
                    <div className="navigation home">
                        <ul className="navigation__list">
                            {naviItems}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}
